import React, { useState, useEffect } from "react";
import { Layout } from "antd";
import {
  HomeOutlined, UserAddOutlined, CalendarOutlined, TeamOutlined,
  MessageOutlined, IdcardOutlined, SmileOutlined, LogoutOutlined,
  MenuUnfoldOutlined, MenuFoldOutlined, EnvironmentOutlined, DesktopOutlined,
  SoundOutlined,
  ToolOutlined,
  ExperimentOutlined
} from "@ant-design/icons";
import { Link, useNavigate, useLocation } from "react-router-dom";
import logo from "../Component/Assets/Untitled design 2.png";
import smalllogo from "../Component/Assets/Skinola favicon icon 2.png";

const { Header, Sider, Content } = Layout;

const C_PINK   = "#F04DA0";
const C_PURPLE = "#8B2FC9";
const C_DARK   = "#1a0040";

const NAV_ITEMS = [
  {
    label: "DASHBOARD",   href: "/Home",            icon: <HomeOutlined />,
    children: [
      { label: "SPOT REGISTRATION", href: "/spotregistration",  icon: <IdcardOutlined />  },
      { label: "LANDING SECTION",   href: "/herosection",       icon: <SmileOutlined />   },
      { label: "WELCOME MESSAGE",   href: "/welcome-message",   icon: <MessageOutlined /> },
      { label: "ABSTRACT MESSAGE",  href: "/Abstract-message",  icon: <MessageOutlined /> },
      { label: "OUR FACULTY",       href: "/faculty",           icon: <IdcardOutlined />  },
      { label: "MANAGE SCHEDULE", href: "/manage-schedule", icon: <CalendarOutlined /> },
      { label: "MANAGE BROCHURE", href: "/manage-brochure", icon: <CalendarOutlined /> },
    ],
  },
  { label: "ADD EVENTS",      href: "/event",           icon: <CalendarOutlined />    },
  
  { label: "REGISTER USER",   href: "/registeruser",    icon: <UserAddOutlined />     },
  { label: "ABSTRACT USER",   href: "/Abstractlist",    icon: <TeamOutlined />        },
  { label: "GET IN TOUCH",    href: "/GetInTouch",      icon: <TeamOutlined />        },
  {
    label: "Scientific Program",   href: "/Scientific-Program",            icon: <ExperimentOutlined/>,
    children: [
      { label: "Workshop", href: "/Workshop",  icon: <ToolOutlined/>  },
      { label: "Conference",   href: "/Conference",       icon: <SoundOutlined/>   },
    ],
  },
  { label: "WEBSITE CONTENT", href: "/website-content", icon: <DesktopOutlined />    },
  { label: "SPEAKER", href: "/speaker", icon: <UserAddOutlined />    },
  { label: "AUDITORIUM",      href: "/Location",        icon: <EnvironmentOutlined /> },
  
  
  
  { label: "FEEDBACK",        href: "/feedback",        icon: <MessageOutlined />     },
];

export default function AppLayout({ children }) {
  const navigate  = useNavigate();
  const location  = useLocation();
  const [collapsed, setCollapsed]         = useState(false);
  const [selectedKey, setSelectedKey]     = useState(null);
  const [showLogoutModal, setShowLogoutModal] = useState(false); // ← NEW

  useEffect(() => {
    const flat = NAV_ITEMS.flatMap(m => m.children ? [m, ...m.children] : [m]);
    const cur  = flat.find(i => location.pathname === i.href);
    setSelectedKey(cur?.label ?? null);
  }, [location.pathname]);

  const handleLogout = () => { localStorage.clear(); navigate("/"); };

  return (
    <>
      <Layout style={{ minHeight: "100vh", fontFamily: "inherit" }}>

        {/* ─── LOGOUT CONFIRMATION POPUP ─── */}
        {showLogoutModal && (
          <div className="logout-overlay">
            <div className="logout-modal">
              <div className="logout-modal-icon">
                <LogoutOutlined />
              </div>
              <h3 className="logout-modal-title">Are you sure?</h3>
              <p className="logout-modal-msg">You are about to logout. You will need to login again to access the admin panel.</p>
              <div className="logout-modal-btns">
                <button className="logout-btn-cancel" onClick={() => setShowLogoutModal(false)}>
                  Cancel
                </button>
                <button className="logout-btn-confirm" onClick={handleLogout}>
                  Logout
                </button>
              </div>
            </div>
          </div>
        )}

        {/* ─── SIDEBAR ─── */}
        <Sider
          width={240}
          collapsedWidth={72}
          collapsible
          collapsed={collapsed}
          onCollapse={setCollapsed}
          trigger={null}
          style={{ 
            background: C_DARK, 
            borderRight: "none", 
            position: "sticky", 
            top: 0,             
            height: "100vh",    
            overflow: "hidden" 
          }}
        >
          <div className="sl-bg-glow sl-bg-glow--top"    />
          <div className="sl-bg-glow sl-bg-glow--bottom" />
          <div className="sl-bg-dots" />

          <div className="sl-logo-wrap">
            <Link to="/Home" style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
              {collapsed
                ? <img src={smalllogo} alt="Logo" style={{ height: 36, width: 36, objectFit: "contain" }} />
                : <img src={logo}      alt="Logo" style={{ height: 40, objectFit: "contain", filter: "brightness(0) invert(1)" }} />
              }
            </Link>
          </div>

          <div className="sl-divider" />
          {!collapsed && <div className="sl-section-lbl">Main Menu</div>}

          <div className="sl-nav">
            <Link to="/Home" className={`sl-item ${selectedKey === "DASHBOARD" ? "sl-item--active" : ""}`}>
              <span className="sl-item-icon"><HomeOutlined /></span>
              {!collapsed && <span className="sl-item-label">Dashboard</span>}
              {!collapsed && selectedKey === "DASHBOARD" && <span className="sl-item-dot" />}
            </Link>

            {!collapsed && (
              <div className="sl-sub-group">
                {NAV_ITEMS[0].children.map(sub => (
                  <Link
                    key={sub.label}
                    to={sub.href}
                    className={`sl-sub-item ${selectedKey === sub.label ? "sl-sub-item--active" : ""}`}
                  >
                    <span className="sl-sub-icon">{sub.icon}</span>
                    <span className="sl-sub-label">{sub.label}</span>
                  </Link>
                ))}
              </div>
            )}

            {!collapsed && <div className="sl-section-lbl" style={{ marginTop: 8 }}>Management</div>}

           {NAV_ITEMS.slice(1).map(item => (
  <div key={item.label}>
    
    <Link
      to={item.href}
      className={`sl-item ${selectedKey === item.label ? "sl-item--active" : ""}`}
    >
      <span className="sl-item-icon">{item.icon}</span>
      {!collapsed && <span className="sl-item-label">{item.label}</span>}
      {!collapsed && selectedKey === item.label && <span className="sl-item-dot" />}
    </Link>

    {/* 👉 Children show kara */}
    {!collapsed && item.children && (
      <div className="sl-sub-group">
        {item.children.map(sub => (
          <Link
            key={sub.label}
            to={sub.href}
            className={`sl-sub-item ${selectedKey === sub.label ? "sl-sub-item--active" : ""}`}
          >
            <span className="sl-sub-icon">{sub.icon}</span>
            <span className="sl-sub-label">{sub.label}</span>
          </Link>
        ))}
      </div>
    )}
    
  </div>
))}
          </div>

          <div className="sl-divider" style={{ marginTop: "auto" }} />

          {/* ── LOGOUT BUTTON → opens modal now ── */}
          <div className="sl-logout" onClick={() => setShowLogoutModal(true)}>
            <span className="sl-item-icon" style={{ color: "#f87171" }}><LogoutOutlined /></span>
            {!collapsed && <span style={{ fontSize: 11.5, fontWeight: 700, color: "#f87171", letterSpacing: "0.08em" }}>LOGOUT</span>}
          </div>
        </Sider>

        <Layout>
          <Header className="app-header">
            <div style={{ display: "flex", alignItems: "center", gap: 14 }}>
              <button
                className="hdr-toggle"
                onClick={() => setCollapsed(c => !c)}
                aria-label="Toggle sidebar"
              >
                {collapsed ? <MenuUnfoldOutlined style={{ fontSize: 18 }} /> : <MenuFoldOutlined style={{ fontSize: 18 }} />}
              </button>
              <div className="hdr-breadcrumb">
                <span className="hdr-bc-root">Admin</span>
                <span className="hdr-bc-sep">/</span>
                <span className="hdr-bc-cur">
                  {selectedKey
                    ? selectedKey.charAt(0) + selectedKey.slice(1).toLowerCase()
                    : "Dashboard"}
                </span>
              </div>
            </div>

            <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
              <button
                className="hdr-site-btn"
                onClick={() => window.open("https://skinola.in/", "_blank")}
              >
                <svg width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24">
                  <circle cx="12" cy="12" r="10"/>
                  <line x1="2" y1="12" x2="22" y2="12"/>
                  <path d="M12 2a15.3 15.3 0 014 10 15.3 15.3 0 01-4 10 15.3 15.3 0 01-4-10 15.3 15.3 0 014-10z"/>
                </svg>
                Visit Website
              </button>
              <button
                className="hdr-avatar"
                onClick={() => navigate("/Userprofile")}
                aria-label="Profile"
              >
                A
              </button>
            </div>
          </Header>

          <Content className="app-content">
            {children}
          </Content>
        </Layout>
      </Layout>

      <style>{`
        /* ─── LOGOUT MODAL ─── */
        .logout-overlay {
          position: fixed; inset: 0; z-index: 9999;
          background: rgba(26,0,64,0.55);
          display: flex; align-items: center; justify-content: center;
          animation: fadeIn 0.18s ease;
        }
        .logout-modal {
          background: #fff; border-radius: 18px;
          padding: 36px 32px 28px;
          width: 340px; max-width: 90vw;
          text-align: center;
          box-shadow: 0 20px 60px rgba(26,0,64,0.22);
          animation: slideUp 0.22s ease;
        }
        .logout-modal-icon {
          width: 56px; height: 56px; border-radius: 50%;
          background: rgba(248,113,113,0.12);
          display: flex; align-items: center; justify-content: center;
          margin: 0 auto 16px;
          font-size: 24px; color: #f87171;
        }
        .logout-modal-title {
          margin: 0 0 10px;
          font-size: 18px; font-weight: 700; color: #1a0040;
        }
        .logout-modal-msg {
          margin: 0 0 24px;
          font-size: 13.5px; color: #6b5f8a; line-height: 1.6;
        }
        .logout-modal-btns {
          display: flex; gap: 12px;
        }
        .logout-btn-cancel {
          flex: 1; padding: 10px;
          border: 1.5px solid #ede5f5; border-radius: 10px;
          background: #faf5ff; color: #4a3a6b;
          font-size: 13.5px; font-weight: 600;
          cursor: pointer; transition: background 0.2s;
        }
        .logout-btn-cancel:hover { background: #f0e4ff; }
        .logout-btn-confirm {
          flex: 1; padding: 10px;
          border: none; border-radius: 10px;
          background: linear-gradient(135deg, #f87171, #ef4444);
          color: #fff; font-size: 13.5px; font-weight: 700;
          cursor: pointer; transition: opacity 0.2s, transform 0.2s;
          box-shadow: 0 4px 14px rgba(248,113,113,0.35);
        }
        .logout-btn-confirm:hover { opacity: 0.9; transform: translateY(-1px); }
        @keyframes fadeIn  { from { opacity: 0 } to { opacity: 1 } }
        @keyframes slideUp { from { transform: translateY(16px); opacity: 0 } to { transform: translateY(0); opacity: 1 } }

        /* ─── (बाकी सगळे CSS तुमचे जसे होते तसेच ─── */
        .sl-bg-glow { position: absolute; border-radius: 50%; pointer-events: none; filter: blur(70px); z-index: 0; }
        .sl-bg-glow--top { width: 280px; height: 280px; top: -100px; left: -80px; background: rgba(240,77,160,0.2); }
        .sl-bg-glow--bottom { width: 260px; height: 260px; bottom: -80px; right: -80px; background: rgba(139,47,201,0.22); }
        .sl-bg-dots { position: absolute; inset: 0; pointer-events: none; z-index: 0; background-image: radial-gradient(rgba(255,255,255,0.04) 1.5px, transparent 1.5px); background-size: 24px 24px; }
        .sl-logo-wrap { position: relative; z-index: 1; padding: 20px 18px 16px; }
        .sl-divider { height: 1px; margin: 0 16px 12px; background: rgba(255,255,255,0.08); position: relative; z-index: 1; }
        .sl-section-lbl { font-size: 10px; font-weight: 800; letter-spacing: 0.14em; text-transform: uppercase; color: rgba(255,255,255,0.28); padding: 4px 20px 10px; position: relative; z-index: 1; }
        .sl-nav { display: flex; flex-direction: column; gap: 2px; padding: 0 10px 10px 10px; position: relative; z-index: 1; flex: 1; overflow-y: auto; scrollbar-width: thin; scrollbar-color: rgba(255,255,255,0.15) transparent; }
        .sl-nav::-webkit-scrollbar { width: 4px; }
        .sl-nav::-webkit-scrollbar-track { background: transparent; }
        .sl-nav::-webkit-scrollbar-thumb { background: rgba(255,255,255,0.15); border-radius: 10px; }
        .sl-nav::-webkit-scrollbar-thumb:hover { background: rgba(240,77,160,0.5); }
        .sl-item { display: flex; align-items: center; gap: 11px; padding: 10px 12px; border-radius: 10px; text-decoration: none !important; color: rgba(255,255,255,0.6) !important; font-size: 11.5px; font-weight: 700; letter-spacing: 0.07em; transition: background 0.2s, color 0.2s; position: relative; }
        .sl-item:hover { background: rgba(255,255,255,0.07); color: #fff !important; }
        .sl-item--active { background: linear-gradient(135deg, rgba(240,77,160,0.22), rgba(139,47,201,0.22)) !important; color: #fff !important; border: 1px solid rgba(240,77,160,0.25); }
        .sl-item-icon { width: 32px; height: 32px; border-radius: 8px; background: rgba(255,255,255,0.07); display: flex; align-items: center; justify-content: center; flex-shrink: 0; font-size: 14px; color: rgba(255,255,255,0.6); transition: background 0.2s, color 0.2s; }
        .sl-item--active .sl-item-icon, .sl-item:hover .sl-item-icon { background: rgba(240,77,160,0.25); color: ${C_PINK}; }
        .sl-item-label { flex: 1; font-size: 11.5px; }
        .sl-item-dot { width: 6px; height: 6px; border-radius: 50%; background: ${C_PINK}; flex-shrink: 0; }
        .sl-sub-group { display: flex; flex-direction: column; gap: 1px; margin: 2px 0 4px 12px; padding-left: 12px; border-left: 1.5px solid rgba(255,255,255,0.1); }
        .sl-sub-item { display: flex; align-items: center; gap: 9px; padding: 8px 10px; border-radius: 8px; text-decoration: none !important; color: rgba(255,255,255,0.45) !important; font-size: 11px; font-weight: 600; letter-spacing: 0.05em; transition: background 0.2s, color 0.2s; }
        .sl-sub-item:hover { background: rgba(255,255,255,0.06); color: rgba(255,255,255,0.85) !important; }
        .sl-sub-item--active { color: ${C_PINK} !important; background: rgba(240,77,160,0.1); }
        .sl-sub-icon { font-size: 12px; flex-shrink: 0; opacity: 0.6; }
        .sl-logout { display: flex; align-items: center; gap: 11px; padding: 12px 22px 20px; cursor: pointer; position: relative; z-index: 1; transition: opacity 0.2s; }
        .sl-logout:hover { opacity: 0.8; }
        .app-header { background: #fff !important; height: 60px !important; line-height: 60px !important; padding: 0 24px !important; display: flex !important; align-items: center !important; justify-content: space-between !important; border-bottom: 1px solid #f0e8f8 !important; box-shadow: 0 1px 12px rgba(26,0,64,0.06) !important; position: sticky !important; top: 0 !important; z-index: 100 !important; }
        .hdr-toggle { width: 36px; height: 36px; border-radius: 9px; border: 1px solid #ede5f5; background: #faf5ff; display: flex; align-items: center; justify-content: center; cursor: pointer; color: ${C_DARK}; transition: background 0.2s, border-color 0.2s; }
        .hdr-toggle:hover { background: #f0e4ff; border-color: rgba(139,47,201,0.25); }
        .hdr-breadcrumb { display: flex; align-items: center; gap: 6px; font-size: 13px; font-weight: 600; color: #5a5070; }
        .hdr-bc-root { color: #9a86b8; }
        .hdr-bc-sep { color: #c4b4d8; }
        .hdr-bc-cur { color: ${C_DARK}; font-weight: 800; }
        .hdr-site-btn { display: inline-flex; align-items: center; gap: 7px; padding: 0px 18px; background: linear-gradient(135deg, ${C_PINK}, ${C_PURPLE}); color: #fff; font-size: 12.5px; font-weight: 700; border: none; border-radius: 9px; cursor: pointer; box-shadow: 0 4px 14px rgba(240,77,160,0.28); transition: transform 0.2s, box-shadow 0.2s; letter-spacing: 0.02em; }
        .hdr-site-btn:hover { transform: translateY(-2px); box-shadow: 0 8px 20px rgba(240,77,160,0.38); }
        .hdr-avatar { width: 36px; height: 36px; border-radius: 50%; background: linear-gradient(135deg, ${C_PINK}, ${C_PURPLE}); color: #fff; font-size: 14px; font-weight: 800; border: none; cursor: pointer; display: flex; align-items: center; justify-content: center; box-shadow: 0 4px 12px rgba(240,77,160,0.3); transition: transform 0.2s, box-shadow 0.2s; }
        .hdr-avatar:hover { transform: scale(1.08); box-shadow: 0 6px 18px rgba(240,77,160,0.42); }
        .app-content { margin: 0 !important; padding: 0 !important; overflow-y: auto !important; height: calc(100vh - 60px) !important; background: #f4eefa !important; }
        .ant-layout-sider-trigger { display: none !important; }
        .ant-menu { border-right: none !important; }
        .ant-layout-sider { display: flex !important; flex-direction: column !important; }
        .ant-layout-sider-children { display: flex !important; flex-direction: column !important; height: 100% !important; }
      `}</style>
    </>
  );
}